import React, { Component } from "react";

class StateView extends Component {
  constructor(props) {
    super(props);

    this.state = { expanded: false };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    this.setState({ expanded: !this.state.expanded });
  }

  componentDidMount() {}

  render() {
    let state = this.props.specs.get(this.props.stateId);
    console.log(
      "state " + state + "children " + JSON.stringify(state.get("children"))
    );
    let childStates = "";
    if (state.get("children"))
      childStates = state
        .get("children")
        .map(stateId => (
          <StateView key={stateId} stateId={stateId} specs={this.props.specs} />
        ));
    return (
      <div
        className="State"
        onClick={e => {
          e.stopPropagation();
          this.handleClick(e);
        }}
      >
        <span>{state.get("name")}</span>
        <br />
        {childStates}
      </div>
    );
  }
}

export default StateView;



// WEBPACK FOOTER //
// ./src/components/StateView.js